export function useTheme () {
  const getStoredTheme = () => localStorage.getItem('theme') || null

  const applyTheme = (theme) => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }

    const color = getComputedStyle(document.documentElement).getPropertyValue('--surface-primary').trim()

    document.documentElement.style.backgroundColor = color

    const existingMetas = document.querySelectorAll('meta[name="theme-color"]')
    existingMetas.forEach(meta => meta.remove())

    const newMeta = document.createElement('meta')
    newMeta.name = 'theme-color'
    newMeta.content = color
    document.head.appendChild(newMeta)

    requestAnimationFrame(() => {
      const mobileHeader = document.querySelector('.mobile-header')
      if (mobileHeader) {
        mobileHeader.style.backgroundColor = color
      }
    })
  }

  const setTheme = (theme) => {
    localStorage.setItem('theme', theme)
    applyTheme(theme)
  }

  const clearTheme = () => {
    localStorage.removeItem('theme')
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)')
    applyTheme(prefersDark.matches ? 'dark' : 'light')

    prefersDark.addEventListener('change', e => {
      if (!getStoredTheme()) {
        applyTheme(e.matches ? 'dark' : 'light')
      }
    })
  }

  const toggleTheme = () => {
    const current = getStoredTheme() || (isDarkMode() ? 'dark' : 'light')
    const newTheme = current === 'light' ? 'dark' : 'light'
    setTheme(newTheme)
    return newTheme
  }

  const initTheme = () => {
    const stored = getStoredTheme()
    if (stored) {
      applyTheme(stored)
    } else {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)')
      applyTheme(prefersDark.matches ? 'dark' : 'light')

      prefersDark.addEventListener('change', e => {
        if (!getStoredTheme()) {
          applyTheme(e.matches ? 'dark' : 'light')
        }
      })
    }
  }

  const isDarkMode = () => {
    const stored = getStoredTheme()
    if (stored) return stored === 'dark'
    return window.matchMedia('(prefers-color-scheme: dark)').matches
  }

  return {
    getStoredTheme,
    setTheme,
    clearTheme,
    toggleTheme,
    initTheme,
    isDarkMode
  }
}
